import {isOneCopilotBrowserTelemetryEnabled} from './telemetry-gate'

export const REPOSITORY_SCOPES = ['repository', 'none', 'unknown'] as const
export type RepositoryScope = (typeof REPOSITORY_SCOPES)[number]

const MAX_TASK_REPOSITORY_SCOPES = 512
const scopesByTask = new Map<string, Exclude<RepositoryScope, 'unknown'>>()

// Repositoryless tasks carry repository id 0, matching turn latency's `repository_backed`.
export function repositoryScopeFromRepositoryId(repositoryId: unknown): RepositoryScope {
  if (typeof repositoryId !== 'number' || !Number.isInteger(repositoryId) || repositoryId < 0) return 'unknown'
  return repositoryId > 0 ? 'repository' : 'none'
}

export function repositoryScopeFromRepositoryBacked(repositoryBacked: boolean | undefined): RepositoryScope {
  return repositoryBacked === undefined ? 'unknown' : repositoryBacked ? 'repository' : 'none'
}

export function recordTaskRepositoryScope(taskId: string | undefined, scope: RepositoryScope): void {
  if (!taskId || scope === 'unknown' || !isOneCopilotBrowserTelemetryEnabled()) return
  scopesByTask.delete(taskId)
  scopesByTask.set(taskId, scope)
  while (scopesByTask.size > MAX_TASK_REPOSITORY_SCOPES) {
    const oldestTaskId = scopesByTask.keys().next().value
    if (!oldestTaskId) break
    scopesByTask.delete(oldestTaskId)
  }
}

export function taskRepositoryScope(taskId: string | undefined): RepositoryScope {
  return (taskId && scopesByTask.get(taskId)) || 'unknown'
}

export function clearTaskRepositoryScopes(): void {
  scopesByTask.clear()
}
